module.exports = __webpack_public_path__ + "img/top-bg-2.0e7fdd79.png";